import { render, staticRenderFns } from "./ConsultoriosSalasEspera.vue?vue&type=template&id=66d6e8be&scoped=true"
import script from "./ConsultoriosSalasEspera.vue?vue&type=script&lang=js"
export * from "./ConsultoriosSalasEspera.vue?vue&type=script&lang=js"
import style0 from "./ConsultoriosSalasEspera.vue?vue&type=style&index=0&id=66d6e8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6e8be",
  null
  
)

export default component.exports